<template>
  <div>

    <TheHeader/>

    <section class="product">
      <div class="list">

        <div class="card" v-for="(item, key) in items" :key="key">
          <div class="picture" @click="goProduct(item.id)">
            <img width="465px" alt="Produkt." :src="getImageUrl(`product/small/${item.photo[0].file}`)"/>
          </div>
          <div class="name">{{ item.name }}</div>
          <div class="detail">
            <a :href="`produkt/${item.id}`" title="Detail.">
              DETAIL
            </a>
          </div>
        </div>

      </div>
    </section>

    <TheFooter/>
  </div>
</template>

<script>
import TheFooter from "@/components/TheFooter.vue";
import TheHeader from "@/components/TheHeader";

export default {
  name: "Catalogue",
  components: {
    TheHeader,
    TheFooter
  },
  data() {
    return {
      items: []
    }
  },
  beforeCreate: function () {
    document.body.id = 'catalogue';
  },
  created() {
    this.getData();
  },
  methods: {
    goProduct(id) {
      this.$router.push({
        name: 'product',
        params: {
          id: id
        }
      });
    },
    getData() {
      const apiUrl = "/data";
      fetch(`${apiUrl}/catalogue.json`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      })
          .then(response => response.json())
          .then(json => {
            console.log("API - catalogue.");

            // data definition
            let data = json;
            console.log(json);

            if (!data.error) {
              this.items = data.data;
            }
            if (data.error) {
              console.log("Error.");
            }
            this.isSubmitting = false;
          })
          .catch(error => {
            console.error("Error:", error);
          });
    }
  }
};
</script>
